import {
	TOGGLE_CREATE_CAMPAIGN_MODAL,
	CLOSE_DIALOG,
	ADD_CAMPAIGN,
	ADD_CAMPAIGNS,
	UPDATE_CAMPAIGN,
	REMOVE_CAMPAIGN,

} from '../constants'

const initialState = {
	modal: {
		open: false,
	},
	campaigns: []
};

export const CampaignReducer = (state = initialState, action) => {
	switch ( action.type ) {
		case TOGGLE_CREATE_CAMPAIGN_MODAL :
			state = {
				...state,
				modal: {
					open: action.payload.modal.open
				}
			};
			break;
		case CLOSE_DIALOG :
				state = {
					...state,
					modal: {
						open: false
					}
				};
			break;

		case ADD_CAMPAIGNS :
			state = {
				...state,
				campaigns: action.payload.campaigns
			};
			break;

		case ADD_CAMPAIGN :
			state = {
				...state,
				campaigns: [
					...state.campaigns,
					{
						title: action.payload.campaign.val().title,
						key: action.payload.campaign.key,
						archived: (
							undefined !== action.payload.campaign.val().archived && true === action.payload.campaign.val().archived
						)
					}
				]
			};
		break;

		default :

			break;

	}

	return state;
};


// WEBPACK FOOTER //
// ./src/reducers/campaigns.js